import React, { useEffect, useState } from "react";
import { Link, useLocation, navigate } from "../components/Router";
import { isBrowser } from "../components/Browser";
import { useSessionContext } from "../components/Session";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import NavDropdown from "react-bootstrap/NavDropdown";
import log from "loglevel";
import { IS_TEST_STAGE } from "../api-config";
// import logo from '../img/earnings-call-logo-small.png';
import logo from "../img/earnings-call-brand.svg";
import logoMobile from "../img/logo-mobile.png";
import searchIcon from "../img/search-img.svg";
import { useNProgress } from "@tanem/react-nprogress";
import loadable from "@loadable/component";
import BreadCrumbTrail from "./BreadCrumbTrail";
import PageLoadComponent from "components/PageLoad";

const SearchBar = loadable(() => import("../containers/SearchBar"));


const BarContainer = ({ animationDuration, children, isFinished }) => (
  <div
    style={{
      opacity: isFinished ? 0 : 1,
      pointerEvents: "none",
      transition: `opacity ${animationDuration}ms linear`,
    }}
  >
    {children}
  </div>
);

const Bar = ({ animationDuration, progress }) => (
  <div
    style={{
      background: "#29d",
      height: 2,
      left: 0,
      marginLeft: `${(-1 + progress) * 100}%`,
      position: "fixed",
      top: 0,
      transition: `margin-left ${animationDuration}ms linear`,
      width: "100%",
      zIndex: 1031,
    }}
  >
    <div
      style={{
        boxShadow: "0 0 10px #29d, 0 0 5px #29d",
        display: "block",
        height: "100%",
        opacity: 1,
        position: "absolute",
        right: 0,
        transform: "rotate(3deg) translate(0px, -4px)",
        width: 100,
      }}
    />
  </div>
);

// If this doesn't do what we want, we could try using this library:
// https://klendi.github.io/react-top-loading-bar/
const Progress = ({ isAnimating }) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating,
    animationDuration: 10,
    incrementDuration: 10,
    minimum: 0.08,
  });

  return (
    <>
      <BarContainer
        animationDuration={animationDuration}
        isFinished={isFinished}
      >
        <Bar animationDuration={animationDuration} progress={progress} />
      </BarContainer>
    </>
  );
};

const isActive = (currentPath, pathToCheck) => {
  log.debug("isActive", currentPath, pathToCheck);
  if (currentPath === pathToCheck) {
    return "active";
  }
  return "";
};

const MainNavbar = (props) => {
  const { isAdminPage, analyticsOptions = {} } = props;
  const navbarClass = isAdminPage ? "top-navbar admin-page" : "top-navbar";
  const { sessionContext, setSessionContext } = useSessionContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchActive, setSearchActive] = useState(false);
  const { isLoggedIn, isAdminUser, session } = sessionContext;
  const sessionTokenExpiration = session ? session.expires : 0;
  const nowInSeconds = Date.now() / 1000;
  const minutesRemaining = Math.floor(
    Math.max(sessionTokenExpiration - nowInSeconds, 0) / 60
  );
  const hoursRemaining = Math.floor(
    Math.max(sessionTokenExpiration - nowInSeconds, 0) / 60 / 60
  );
  const { email, givenName, name, imageUrl } = sessionContext.userInfo || {};
  const firstName = givenName || name || email;
  const { pathname, search, hash } = useLocation();
  log.debug("MainNavbar::pathname", pathname, hash);
  const newLocation = `${pathname}${search}${hash}`;
  log.debug("MainNavbar::newLocation", newLocation);
  // log.debug(`UserInfo: ${JSON.stringify(sessionContext.userInfo)}`);

  useEffect(() => {
    // For now, disable the loading bar, due to bad lighthouse stats from this
    // setIsLoading(true);
    // setTimeout(() => setIsLoading(false), 500);
    // setTimeout(() => setIsLoading(false), 200);
  }, [pathname, hash, sessionContext, analyticsOptions]);

  const onLogout = () => {
    log.debug("Logout.");
    setSessionContext({});
    navigate("/");
  };

  if (
    isBrowser() &&
    isLoggedIn &&
    session &&
    nowInSeconds > sessionTokenExpiration
  ) {
    log.debug("Expired, logging user out of session.");
    setSessionContext({});
    if (isAdminPage) {
      log.debug("Current path is an admin page, navigating back to home.");
      navigate("/");
    }
  }

  return (
    <>
      <Progress isAnimating={isLoading} />
      <PageLoadComponent {...props} />
      <Navbar
        expand="md"
        className={`main-navbar ${navbarClass} ${isSearchActive ? "active-search" : ""}`}
        sticky="top"
      >
        <Container>
          <Navbar.Brand as={Link} to="/">
            {IS_TEST_STAGE && false && "TEST"}
            <img
              src={logo}
              alt="EarningsCall Logo"
              className="d-sm-block d-none"
              style={{ width: "200px" }}
            />
            <img
              src={logoMobile}
              className="d-sm-none d-block"
              alt="EarningsCall Logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse className="" id="basic-navbar-nav">
            {/* close mobile side navbar */}

            <div className="mobile-nav-close">
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                className="without-focus"
              >
                <div className="nav-close">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#fff"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </div>
              </Navbar.Toggle>
            </div>

            {isAdminUser && (
              <>
                <NavDropdown title="ADMIN" id="basic-nav-dropdown">
                  <NavDropdown.Item as={Link} to="/news">
                    News
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/earnings">
                    Earnings
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/company">
                    Company Info
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/audit">
                    Audit History
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/builds">
                    App Builds
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  {/* NOTE: This is not a Gatsby Link because we are navigating to Kibana, which is a completely
                            separate app.
                    */}
                  <NavDropdown.Item href="/_plugin/kibana">
                    Kibana
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/newcalendar">
                    Calendar Overview
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            )}
            <ul className="navbar-nav align-items-md-center ml-md-auto">
              {isAdminUser && (
                <>
                  <li className="nav-item">
                    <Nav.Link as={Link} to="/test">
                      Test
                    </Nav.Link>
                  </li>
                </>
              )}

              <li className="nav-item d-none">
                <Nav.Link
                  as={Link}
                  to="/search"
                  className={isActive(pathname, "/search")}
                >
                  Search
                </Nav.Link>
              </li>
              <li className="nav-item d-md-block d-none">
                <Nav.Link
                  as={Link}
                  to="/calendar"
                  className={isActive(pathname, "/calendar")}
                >
                  Calendar
                </Nav.Link>
              </li>
              <li className="nav-item">
                <Nav.Link
                  as={Link}
                  to="/about"
                  className={isActive(pathname, "/about")}
                >
                  About
                </Nav.Link>
              </li>
              <li className="nav-item d-md-none">
                <Nav.Link
                  as={Link}
                  to="/terms"
                  className={isActive(pathname, "/terms")}
                >
                  Terms of Use
                </Nav.Link>
              </li>
              <li className="nav-item d-md-none">
                <Nav.Link
                  as={Link}
                  to="/privacy"
                  className={isActive(pathname, "/privacy")}
                >
                  Privacy Policy
                </Nav.Link>
              </li>
              <li className="nav-item d-md-block d-none">
                <img
                  onClick={() => setSearchActive(true)}
                  src={searchIcon}
                  alt="search icon"
                  style={{ width: "20px" }}
                />
              </li>
              {isLoggedIn ? (
                <>
                  {isAdminUser && false && (
                    <>
                      <Navbar.Text
                        style={{ color: "rgba(255, 195, 158, 0.5)" }}
                        className="mr-4"
                      >
                        ADMIN
                      </Navbar.Text>
                    </>
                  )}
                  {email && (
                    <NavDropdown
                      title={
                        <>
                          <span className="profile-cover">
                            <img src={imageUrl || logoMobile} alt="EarningsCall Logo" />
                          </span>
                          <span className="profile-name">{firstName}</span>
                        </>
                      }
                      id="basic-nav-dropdown"
                    >
                      <NavDropdown.Item as={Link} to="/account" className={isActive(pathname, "/account")}>
                        Account
                      </NavDropdown.Item>
                      <NavDropdown.Item as="button" onClick={onLogout}>
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}
                </>
              ) : (
                <>
                  <Nav.Link
                    as={Link}
                    to="/login"
                    className={`btn d-md-block d-none ${isActive(
                      pathname,
                      "/login"
                    )}`}
                  >
                    Login
                  </Nav.Link>
                </>
              )}
            </ul>

            <p className="mt-auto copy-right-text">
              &copy;Earnings Call, LLC {new Date().getFullYear()}
            </p>

            {isLoggedIn && session && false && (
              <Navbar.Text className="mr-2">
                Session Token Hours Left: {hoursRemaining}
              </Navbar.Text>
            )}
          </Navbar.Collapse>

          <div className="search-bar">
            <span className="nav-bar-company-search d-flex my-1">
              <SearchBar
                renderForm={false}
                renderSearchButton={false}
                placeholder="Find company"
              />

              <span
                className="close-search"
                onClick={() => setSearchActive(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#fff"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </span>
            </span>
          </div>
        </Container>
      </Navbar>
      <BreadCrumbTrail />
    </>
  );
};

export default MainNavbar;
